import arrayMove from 'utils/arrayMove';

export const onSortEnd = (list: any[], sourceIndex: number, destinationIndex: number): any[] => {
  if (list[sourceIndex].is_default || list[destinationIndex].is_default) {
    return list;
  }

  return arrayMove(list, sourceIndex, destinationIndex);
};
